import { useMemo } from 'react';
import { Button } from 'react-bootstrap';

import { ButtonSplitGroup } from '@components/Buttons';
import { BootstrapTable } from '@components/Table/Table';

export const PricelistTable = ({
  data,
  isLoading,
  tariff,
  setTariff,
  setPricelistLocation,
}) => {
  const renderDownloadCell = ({ row }) => {
    const {
      location,
      pdf_location: pdfLocation,
      csv_location: csvLocation,
      xlsx_location: xlsxLocation,
      tariff: tariffValue,
    } = row.original;
    return (
      <ButtonSplitGroup>
        {location ? (
          <Button
            size="sm"
            variant="didxl"
            onClick={() => {
              if (tariff === tariffValue) {
                setTariff(null);
                setPricelistLocation(null);
                return;
              }
              setTariff(tariffValue);
              setPricelistLocation(location);
            }}
          >
            Display
          </Button>
        ) : null}
        {pdfLocation ? (
          <Button
            size="sm"
            variant="didxl"
            as="a"
            href={pdfLocation}
            target="_blank"
          >
            PDF
          </Button>
        ) : null}
        {csvLocation ? (
          <Button
            size="sm"
            variant="didxl"
            as="a"
            href={csvLocation}
            target="_blank"
          >
            CSV
          </Button>
        ) : null}
        {xlsxLocation ? (
          <Button
            size="sm"
            variant="didxl"
            as="a"
            href={xlsxLocation}
            target="_blank"
          >
            XLSX
          </Button>
        ) : null}
      </ButtonSplitGroup>
    );
  };

  const columns = useMemo(
    () => [
      {
        Header: 'Document',
        accessor: 'description',
      },
      {
        Header: 'Download',
        accessor: 'actions',
        Cell: renderDownloadCell,
      },
    ],
    [tariff]
  );
  return (
    <BootstrapTable
      columns={columns}
      data={data}
      tableProps={() => ({ responsive: true, borderless: true })}
      isLoading={isLoading}
    />
  );
};
